// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1IwFt","loaderOuter":"PageOverlayLoader_loaderOuter__1pk0Y"};